// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_type {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
  margin-bottom: 5px;
}

.text-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.text-block ion-skeleton-text {
  display: inline-block;
}

@media (max-width: 992px) {
  .desktop-logo {
    display: none;
  }
}

.back-block,
.venue_info_block,
.burger_block {
  display: flex;
  align-items: center;
}

.venue_info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 70%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-skeleton-header/menu-skeleton-header.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAKA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAJD;;AAOA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;AAJD;AAMC;EACC,qBAAA;AAJF;;ACRE;EDgBF;IAEE,aAAA;EALA;AACF;;AASA;;;EAGC,aAAA;EACA,mBAAA;AAND;;AASA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AAND","sourcesContent":["@import '../../../theme/mixins';\n\n// Skeleton header inherits styles from menu.page.scss\n// Additional styling for skeleton-specific elements\n\n.text_type {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding-top: 5px;\n\tmargin-bottom: 5px;\n}\n\n.text-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\n\tion-skeleton-text {\n\t\tdisplay: inline-block;\n\t}\n}\n\n.desktop-logo {\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n}\n\n// Ensure skeleton elements maintain proper spacing\n.back-block,\n.venue_info_block,\n.burger_block {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.venue_info {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tmax-width: 70%;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
